import { useEffect, useState } from "react";
import { differenceInMinutes, subMinutes } from "date-fns";
import style from "./style.module.css"
import Timer from "./Timer";
import { toast } from "react-toastify";
import videoPoster from "../../../assets/video-poster.png"
import collegeLogo from "../../../assets/college-logo.png"
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Helmet } from "react-helmet";
import JistiHandler from "./JitsiHandler";
import ScreenLeftCount from "./ScreenLeftCount";
import { incScreenLeftCount } from "../../../redux/actions/TestActions";
import axios from "axios";
import { io } from "socket.io-client";
import { BaseSocketUrl } from "../../../utils/BaseApi";


const AttemptExam = () => {

    const TestReducer = useSelector(store => store.TestReducer);
    const StudentDetails = useSelector(store => store.AuthReducer.studentData);
    const dispatch = useDispatch()
    var time = new Date();
    var startTimeDifference = differenceInMinutes(new Date(TestReducer.startDateTime), new Date());
    time = startTimeDifference > 0 ? subMinutes(new Date(TestReducer.endDateTime), startTimeDifference) : new Date(TestReducer.endDateTime)
    const navigate = useNavigate()
    const [error, setError] = useState("");
    const [micAverage, setMicAverage] = useState(0)
    const [questions, setQuestions] = useState(TestReducer.questions);
    const [activeQuestion, setActiveQuestion] = useState(0)
    const [isAllQuetionsActive, setIsAllQuestionsActive] = useState(false)
    const [screenLeftPopup, setScreenLeftPopup] = useState(false)
    const [isLoading, setIsLoading] = useState(false)



    const selectAnswer = (answer) => {
        const reqBody = {
            queIndex: activeQuestion,
            answer: answer
        }
        axios.patch(`/updateAnswerByIndex/${TestReducer._id}`, reqBody)
            .then(res => {
                console.log(res)
            })
            .catch(err => {

                console.log(err)
                console.log(err.response)
                if (err.response) {
                    toast.error(err.response.data.msg)
                }
                else {
                    redirectToExamsOnNetworkError()
                }
            })
        setQuestions(questions => {
            questions[activeQuestion].studentAnswer = answer
            return [...questions]
        })
    }

    const nextQue = () => {
        setActiveQuestion(activeQuestion => activeQuestion + 1)
    }
    const prevQue = () => {
        setActiveQuestion(activeQuestion => activeQuestion - 1)
    }
    const clearResponse = () => {
        const reqBody = {
            queIndex: activeQuestion,
            answer: null
        }
        axios.patch(`/updateAnswerByIndex/${TestReducer._id}`, reqBody)
            .then(res => {
                console.log(res)
            })
            .catch(err => {

                console.log(err)
                console.log(err.response)
                if (err.response) {
                    toast.error(err.response.data.msg)
                }
                else {
                    redirectToExamsOnNetworkError()
                }
            })
        setQuestions(questions => {
            questions[activeQuestion].studentAnswer = null;
            return [...questions]
        })
    }
    const validation = () => {
        var isValid = true;
        var remainingQue = `Please select answers for questions - `;
        for (let i = 0; i < questions.length; i++) {
            const question = questions[i];
            if (!question.studentAnswer) {
                remainingQue = remainingQue + " " + (i + 1);
                isValid = false

            }

        }

        if (isValid) {
            return isValid;
        }
        else {
            toast.error(remainingQue)
            return isValid;
        }
    }

    const submitTest = (submitMsg = "Test submitted successfully.!", validate = true) => {
        if (validate) {
            if (validation()) {
                setIsLoading(true)
                const reqBody = {
                    questions
                }
                console.log(reqBody)
                axios.post(`/submitTest/${TestReducer._id}`, reqBody)
                    .then(res => {
                        console.log(res)
                        toast.success(submitMsg)
                        navigate("/exams", { replace: true })
                        setIsLoading(true)
                    })
                    .catch(err => {
                        console.log(err)
                        console.log(err.response)
                        setIsLoading(false)
                        toast.error("Something went wrong")
                    })
            }
        }
        else if (!validate) {
            setIsLoading(true)
            const reqBody = {
                questions
            }
            console.log(reqBody)
            axios.post(`/submitTest/${TestReducer._id}`, reqBody)
                .then(res => {
                    console.log(res)
                    toast.success(submitMsg)
                    navigate("/exams", { replace: true })
                    setIsLoading(true)
                })
                .catch(err => {
                    console.log(err)
                    console.log(err.response)
                    setIsLoading(false)
                    toast.error("Something went wrong")
                })
        }

    }


    const redirectToExamsOnNetworkError = () => {
        toast.error("Network error occured can't continue test");
        navigate("/exams", { replace: true })
    }

    useEffect(() => {

        if (TestReducer._id) {

            axios.patch(`/updateExamStatus/${TestReducer._id}`)
                .then(res => {
                    console.log(res)
                })
                .catch(err => {
                    console.log(err)
                    console.log(err.response)
                    // toast.error("Something went wrong cant start test now")

                    // navigate("/exams", { replace: true })
                })

            navigator.mediaDevices.getUserMedia({
                audio: true,
                video: {
                    facingMode: {
                        exact: "user"
                    }
                }
            })
                .then(function (stream) {

                    console.log(stream)
                    stream.oninactive = () => {
                        console.log("on inactive")
                        toast.error("Camera or mic disconnected :(")
                    }
                    stream.onremovetrack = () => {
                        toast.error("Camera or mic disconnected :(")
                    }
                    var video = document.getElementById('videoTag');
                    console.log(stream.getVideoTracks())
                    console.log(stream.getAudioTracks())
                    if (video) {
                        video.srcObject = stream;
                    }

                    const audioContext = new AudioContext();
                    const analyser = audioContext.createAnalyser();
                    const microphone = audioContext.createMediaStreamSource(stream);
                    const scriptProcessor = audioContext.createScriptProcessor(2048, 1, 1);

                    analyser.smoothingTimeConstant = 0.8;
                    analyser.fftSize = 1024;

                    microphone.connect(analyser);
                    analyser.connect(scriptProcessor);
                    scriptProcessor.connect(audioContext.destination);
                    scriptProcessor.onaudioprocess = function () {
                        const array = new Uint8Array(analyser.frequencyBinCount);
                        analyser.getByteFrequencyData(array);
                        const arraySum = array.reduce((a, value) => a + value, 0);
                        const average = arraySum / array.length;
                        // console.log(Math.round(average));
                        setMicAverage(Math.round(average))
                    };
                })
                .catch(function (err) {
                    /* handle the error */
                    console.error({ errorIs: err });
                    setError(err.message)
                    toast.error(err.message)
                });
        }
        else {
            console.log("redirecting")
            navigate("/exams", { replace: true })
        }
    }, [TestReducer._id, navigate])

    useEffect(() => {
        window.onblur = () => {
            console.log("screen left detected")
            axios.patch(`/incrementScreenLeftCount/${TestReducer._id}`)
                .then(res => {
                    console.log(res)
                })
                .catch(err => {
                    console.log(err)
                    console.log(err.response)
                    if (err.response) {
                        toast.error(err.response.data.msg)
                    }
                    else {
                        toast.error("Network error occured can't continue test");
                        navigate("/exams", { replace: true })
                    }
                })
            dispatch(incScreenLeftCount())
            setScreenLeftPopup(true)
        }
    }, [dispatch, navigate, TestReducer._id])


    useEffect(() => {
        if (5 - TestReducer.screen_left_count <= 0) {
            toast.error("You left screen more than 5 times! Your exam will be auto submitted");
            setIsLoading(true)
            const reqBody = {
                questions
            }
            console.log(reqBody)
            axios.post(`/submitTest/${TestReducer._id}`, reqBody)
                .then(res => {
                    console.log(res)
                    toast.success("Test Submitted Successfully.!")
                    navigate("/exams", { replace: true })
                    setIsLoading(true)
                })
                .catch(err => {
                    console.log(err)
                    console.log(err.response)
                    setIsLoading(false)
                    toast.error("Something went wrong")
                })
            navigate("/exams", { replace: true })
        }
    }, [TestReducer.screen_left_count,TestReducer._id, questions, navigate])

    useEffect(() => {
        if (error) {
            navigate("/exams", { replace: true })
            toast.error("Some error occured with camera or microphone connectivity you can appear htmlFor exam.")
        }
    }, [error, navigate])


    useEffect(() => {
        const socket = io(BaseSocketUrl);
        socket.emit("student-join", { id: TestReducer._id }, (data) => {
            console.log("---------------- student join ---------------------")
            console.log(data)
            console.log("---------------- student join ---------------------")
        })

        socket.on("newInstruction", (data) => {
            console.log("----------------- new instruction --------------------")
            console.log(data)
            console.log("----------------- new instruction --------------------")
            if (data.type === "msg") {
                toast.info(data.text)
            }
            else {
                console.log(data._id)
                console.log(TestReducer.s_id)
                if (data.text.includes("got banned") && data._id === TestReducer.s_id) {
                    toast.error("You Got Banned From Exam By Examiner!")
                    navigate("/exams", { replace: true })
                }
                else if (data.text.includes("got banned")) {
                    toast.error(data.text)
                }
            }
        })


        return () => {
            socket.close()
        }
    }, [TestReducer._id, TestReducer.s_id, navigate])
    return (
        <div className={style.mainDiv}>
            <Helmet>
                <title>{TestReducer.exam_id ? TestReducer.exam_id.subjectName : ""} | Secure Examination</title>
            </Helmet>
            {
                TestReducer._id
                &&
                <JistiHandler />
            }
            {
                screenLeftPopup
                &&
                <ScreenLeftCount
                    closePopup={() => setScreenLeftPopup(false)}
                />
            }
            <div className={style.collegeDetails}>
                <div className={style.clgLogo}>
                    <img className={style.clgLogoImg} src={collegeLogo} alt="..." />
                </div>
                <div className={style.clgNameDetails}>
                    <p className={style.instituteName}>Padmashri Annasaheb Jadhav Bharatiya Samaj Unnati Mandal’s</p>
                    <p className={style.collegeName}>B. N. N. College of Arts, Science & Commerce, Bhiwandi.</p>
                </div>
            </div>
            <div className={style.header}>
                <div className={style.examNameWrapper}>
                    <p className={style.examName}>{TestReducer.exam_id ? TestReducer.exam_id.subjectName : ""}</p>
                    <p className={style.examinationAndTime}><span className={style.examinationGrp}>{TestReducer.exam_id ? TestReducer.exam_id.examinationGroup.name : ""}</span>
                        <Timer expiryTime={time} onExpire={() => submitTest("Time Up! Test Submitted Successfully", false)} />
                    </p>
                </div>

                <div className={style.videoWrapper}>
                    <div className={style.StudentDetails}>
                        <p className={style.studentName}>{StudentDetails.name}</p>
                        <p className={style.studentUid}>{StudentDetails.uid}</p>
                    </div>
                    <video className={style.studentVideo} id="videoTag" poster={videoPoster} playsInline autoPlay muted></video>
                    <div className={style.micMainDiv}>
                        <div className={`${style.firstBar} ${micAverage > 25 && style.sideBarAnimation}`}></div>
                        <div className={`${style.secondBar} ${micAverage > 25 && style.mainBarAnimation}`}></div>
                        <div className={`${style.thirdBar} ${micAverage > 25 && style.sideBarAnimation}`}></div>
                    </div>
                </div>
            </div>
            <div className={style.mainQuestionsWrapper}>
                <div className={style.questionWrapper}>
                    <p className={style.queHeading}><span>Question {activeQuestion + 1}<span style={{ fontSize: ".7rem", marginLeft: "1rem" }}>{questions.length > 0 && questions[activeQuestion].marks} marks</span></span><i onClick={() => setIsAllQuestionsActive(true)} className={"fa-solid fa-bars " + style.menuIcon}></i></p>
                    <p className={style.queTitle}>{questions.length > 0 && questions[activeQuestion].queTitle}</p>
                    <div className={style.optionsWrapper}>
                        {
                            questions.length > 0 && questions[activeQuestion].options.map((option, index) => {
                                return (
                                    <div onClick={() => selectAnswer(option)} key={index} className={style.optionWrapper}>

                                        <div className={style.round}>
                                            <input type="checkbox" checked={option === questions[activeQuestion].studentAnswer} id={`checkbox-${index}`} />
                                            <label className={style.roundLabel} htmlFor={`checkbox-${index}`}></label>
                                        </div>
                                        <p className={style.optionTxt}>{option}</p>
                                    </div>
                                )
                            })
                        }
                    </div>
                </div>
                <div className={`${style.allQuestionsWrapper} ${isAllQuetionsActive ? style.allQuestionsWrapperActive : ""}`}>
                    <i onClick={() => setIsAllQuestionsActive(false)} className={"fa-solid fa-xmark " + style.closeAllQueIcon}></i>
                    <p className={style.allQueHeading}>All Questions ({questions.length})</p>
                    <div className={style.allQuesIndexWrapper}>
                        {
                            questions.map((que, index) => {
                                return <span key={index} onClick={() => setActiveQuestion(index)} className={`${style.queIndex} ${activeQuestion === index ? style.activeQuestion : ""}`}>{index + 1}</span>
                            })
                        }
                        {/* <span className={`${style.queIndex} ${style.activeQuestion}`}>3</span> */}
                    </div>
                </div>
            </div>
            <div className={style.buttonsWrapper}>
                {
                    questions.length > 0 && questions[activeQuestion].studentAnswer !== null
                    &&
                    <button onClick={() => clearResponse()} className={`${style.btnStyle} ${style.white}`}>Clear Response</button>
                }
                {
                    activeQuestion !== 0
                    &&
                    <button onClick={() => prevQue()} className={`${style.btnStyle} ${style.backBtn}`}>Previous Question</button>
                }

                {
                    (activeQuestion + 1) !== questions.length
                    &&
                    <button onClick={() => nextQue()} className={`${style.btnStyle} ${style.nextBtn}`}>Next Question</button>
                }
                {
                    isLoading
                        ?
                        <button className={`${style.btnStyle} ${style.submitBtn}`}>
                            <div className="spinner-border" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>
                        </button>
                        :
                        <button onClick={() => submitTest()} className={`${style.btnStyle} ${style.submitBtn}`}>Submit Test</button>
                }
            </div>
        </div>
    )
}
export default AttemptExam;